// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"558bb18a","146":"c9fcc728","163":"a43a3cd8","453":"f7dacc60","566":"ed80473d","811":"781e334c","896":"16d58906"}[chunkId] + ".chunk.js";
};